import { fetchRadarPredictions, RADAR_LAYERS } from '@garnish/location';

import { getEnvVars } from '@order/utils';

// ─────────────────────────────────────────────────────────────────────────────

export async function fetchPredictions(
  searchString: string,
  options: FetchPredictionsOptions = {},
) {
  const { near } = options;

  const { RADAR_SDK_KEY } = getEnvVars();

  const data = await fetchRadarPredictions({
    query: searchString,
    apiKey: RADAR_SDK_KEY,
    layers: [RADAR_LAYERS.COARSE],
    near,
  });

  return { predictions: data.addresses };
}

// ─── Types ───────────────────────────────────────────────────────────────────

type FetchPredictionsOptions = {
  near?: string; // location bias in "latitude,longitude" format
};
